import { memo, useCallback } from "react";
import SearchActions from "../SearchActions";
import { Serializer } from "@shared/mirage/helpers/Serializer";
import { EntityTableStateStorage } from "@mirage/components/entityTable/EntityTableStateStorage";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { PropertySearchFilter } from "@shared/publicportal/contracts/PropertySearchFilter";
import "./PropertySearch.css";
import { atom, useRecoilState } from "recoil";
import PublicPortalState from "@publicPortal/utils/InitialState";
import PropertySearchFields from "./PropertySearchFields";
import { useStableNavigate } from "@mirage/hooks/useStableNavigate";

const pp = new PublicPortalRoutingService();
const { initialSearchState } = PublicPortalState.propertySearch();
export const propertySearchState = atom({
    key: "propertySearchState",
    default: initialSearchState,
});

const PropertySearch = memo(() => {
    const navigate = useStableNavigate();
    const [addressDetails, setAddressDetails] = useRecoilState<{ filter: PropertySearchFilter }>(propertySearchState);
    const setStateModifier = useCallback(
        (modifier: Partial<PropertySearchFilter>) => {
            setAddressDetails((prev) => {
                return { ...prev, filter: { ...prev.filter, ...modifier } };
            });
        },
        [setAddressDetails]
    );
    const onClear = useCallback(() => setAddressDetails(initialSearchState), [setAddressDetails]);
    const onSubmit = useCallback(() => {
        const filter = { uprn: addressDetails.filter.uprn };
        const searchParams = Serializer.toQueryParamsNotEmptyOnly(filter);
        EntityTableStateStorage.clear("propertySearch");
        navigate(`${pp.SearchRoute("PropertySearch", searchParams)}`);
    }, [addressDetails.filter.uprn, navigate]);

    return (
        <>
            <PropertySearchFields state={addressDetails.filter} setStateModifier={setStateModifier} />
            <SearchActions onCancelHandler={onClear} onSubmitHandler={onSubmit} />
        </>
    );
});

export default PropertySearch;
